import React from "react";

export default function Credit() {
  return (
    <div className="credit">
      <p>(c) 2024 Rizki Fikriansyah</p>
    </div>
  );
}
